export default {
      id: "i-main-investments-02-usage",
      viewBox: "0 0 200 100",
      url: __webpack_public_path__ + "img/sprite.svg#i-main-investments-02",
      toString: function () {
        return this.url;
      }
    }